import { ProductOptionCategoryObject } from '../types/joostconnector';
import { Request } from './base/Request';
import { Method } from 'axios';

export default class ProductOptionCategoryRequest extends Request<
  [ProductOptionCategoryObject[]]
> {
  private productSku: string = '';

  protected getEndPoint(): string {
    return `${window.base_url}rest/V1/canvascompany/joostconnector/product-options/${this.productSku}`;
  }

  protected getMethod(): Method {
    return 'GET';
  }

  setProductSku(sku: string): this {
    this.productSku = sku;
    return this;
  }
}
